export default "__VITE_ASSET__CHlEX7o$__"